class SoftvoyageData {
    constructor() {
        this.dataPromise = this.requestData();
        this.data = null;
        this.dataPromise.then((data) => {
            this.data = data;
        });
        this.gatewaysData = {};
        this.modalData = {};
    }

    requestData() {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            const lang = (window.Locale === 'fr') ? `/${window.Locale}` : '';
            const url = '/api/autocompletes/vacation-data';
            xhr.open('GET', url);
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    const data = JSON.parse(xhr.response);
                    this.data = data;
                    resolve(data);
                } else {
                    reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
                }
            };
            xhr.onerror = () => {
                reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            };
            xhr.send();
        });
    }

    requestGatewayData(gateway) {
        return new Promise((resolve, reject) => {
            const lang = (window.Locale === 'fr') ? `/${window.Locale}` : '';
            const affiliateParameter = (window.affiliate !== undefined) ? `/${window.affiliate}` : '';
            const baseDestination = fetch(`${lang}/api/autocompletes/vacation-destinations/${gateway.toLowerCase()}${affiliateParameter}`);

            baseDestination.then((response) => response.json())
                .then((base) => {
                    this.gatewaysData[gateway] = base;
                    // this.modalData[gateway] = modal.data;
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
        });
    }

    requestModalData(gateway) {
        return new Promise((resolve, reject) => {
            const lang = (window.Locale === 'fr') ? `/${window.Locale}` : '';
            const affiliateParameter = (window.affiliate !== undefined) ? `/${window.affiliate}` : '';
            const modalDestinations = fetch(`${lang}/engine/vacations/modaldestinations/${gateway.toLowerCase()}${affiliateParameter}`);

            modalDestinations.then((modal) => {
                this.modalData[gateway] = modal.data;
                resolve(true);
            })
                .catch(() => {
                    reject(false);
                });
        });
    }

    checkData() {
        return new Promise((resolve) => {
            if (this.data !== null) {
                resolve(true);
            } else {
                this.dataPromise.then(() => {
                    resolve(true);
                });
            }
        });
    }

    checkGatewayData(gateway) {
        return new Promise((resolve) => {
            if (!Object.prototype.hasOwnProperty.call(this.gatewaysData, gateway)) {
                this.requestGatewayData(gateway).then(() => {
                    resolve(true);
                });
            } else {
                resolve(true);
            }
        });
    }

    getGateways() {
        return new Promise((resolve) => {
            this.checkData().then(() => {
                const keys = Object.keys(this.data.a);

                const response = keys.map((key, index) => (
                    {
                        id: index,
                        text: this.data.a[key],
                        value: key,
                        displayClass: 'group',
                    }
                ));
                resolve(response);
            });
        });
    }

    getGatewayData(gateway) {
        return new Promise((resolve) => {
            this.checkGatewayData(gateway).then(() => {
                this.checkData().then(() => {
                    const response = this.parseGatewayData(gateway);
                    resolve(response);
                });
            });
        });
    }

    checkModalData(gateway) {
        return new Promise((resolve) => {
            if (!Object.prototype.hasOwnProperty.call(this.modalData, gateway)) {
                this.requestModalData(gateway).then(() => {
                    resolve(true);
                });
            } else {
                resolve(true);
            }
        });
    }

    getModalData(gateway) {
        return new Promise((resolve) => {
            this.checkModalData(gateway).then(() => {
                this.checkData().then(() => {
                    const response = this.parseModalData(gateway);
                    resolve(response);
                });
            });
        });
    }

    static arrayUnique(array) {
        const a = array.concat();
        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j]) {
                    a.splice(j, 1);
                    j -= 1;
                }
            }
        }
        return a;
    }

    static sortDurations(a, b) {
        const A = parseInt(a, 10);
        const B = parseInt(b, 10);
        if (A > B) {
            return 1;
        }
        return -1;
    }

    parseGatewayData(gateway) {
        const data = this.gatewaysData[gateway];
        const gatewayData = { g: [], h: [], c: [] };
        const softvoyageData = this.data;

        data.g.forEach((group) => {
            const element = {
                index: `g-${group.id}`,
                text: softvoyageData.g[group.id],
                destinations: group.i.join(','),
                displayClass: 'group',
                hotels: [],
                destinationData: [],
            };
            let groupDurations = [];
            let groupChains = [];
            group.i.forEach((destination) => {
                groupDurations = SoftvoyageData.arrayUnique(groupDurations.concat(data.i[destination].d)).sort(SoftvoyageData.sortDurations);
                groupChains = SoftvoyageData.arrayUnique(groupChains.concat(data.i[destination].c));
                const regexAll = /\b(all|tout)\b/i;
                if (!regexAll.test(element.text)) {
                    element.destinationData.push({
                        index: `g-${group.id}-d-${destination}`,
                        text: softvoyageData.i[destination],
                        destinations: destination,
                        displayClass: 'destination',
                        hotels: [],
                        durations: data.i[destination].d.join(','),
                    });

                    data.i[destination].h.forEach((hotel) => {
                        gatewayData.h.push({
                            index: `h-${hotel}`,
                            text: `${softvoyageData.h[hotel]} - ${softvoyageData.i[destination]}`,
                            destinations: destination,
                            displayClass: 'hotel',
                            hotels: hotel,
                            durations: data.i[destination].d.join(','),
                        });
                    });

                    data.i[destination].c.forEach((chain) => {
                        if (chain !== '') {
                            gatewayData.c.push({
                                index: `c-${chain}-d-${destination}`,
                                text: `${softvoyageData.c[chain].n} - ${softvoyageData.i[destination]}`,
                                destinations: destination,
                                displayClass: 'chain',
                                hotels: softvoyageData.c[chain].h.join(','),
                                durations: data.i[destination].d.join(','),
                            });
                        }
                    });
                }
            });

            element.destinationData.sort((a, b) => {
                if (a.text > b.text) {
                    return 1;
                }
                if (a.text < b.text) {
                    return -1;
                }
                return 0;
            });

            element.durations = groupDurations.join(',');
            groupChains.forEach((chain) => {
                if (chain !== '') {
                    gatewayData.c.push({
                        index: `c-${chain}-g-${group.id}`,
                        text: `${softvoyageData.c[chain].n} - ${softvoyageData.g[group.id]}`,
                        destinations: group.i.join(','),
                        displayClass: 'chain',
                        hotels: softvoyageData.c[chain].h.join(','),
                        durations: groupDurations.join(','),
                    });
                }
            });
            gatewayData.g.push(element);
        });

        gatewayData.g.sort((a, b) => {
            const regexAll = /\b(all|tout)\b/i;

            if (regexAll.test(a.text) || regexAll.test(b.text)) {
                const groupAParts = a.index.split('-');
                const groupBParts = b.index.split('-');
                if (parseInt(groupAParts[1], 10) < groupBParts[1]) {
                    return -1;
                }
                return 1;
            }
            if (a.text > b.text) {
                return 1;
            }
            if (a.text < b.text) {
                return -1;
            }
            return 0;
        });

        return gatewayData;
    }

    static modalSortCountries(a, b) {
        if (a.name === undefined || b.name === undefined) {
            return 0;
        }
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        return 0;
    }

    static modalSortDestinations(a, b) {
        if (a.text === undefined || b.text === undefined) {
            return 0;
        }
        const nameA = a.text.toUpperCase();
        const nameB = b.text.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        return 0;
    }

    parseModalData(gateway) {
        const data = this.modalData[gateway];
        const softvoyageData = this.data;
        const modalData = [];

        data.lists.forEach((section) => {
            const sectionData = {
                name: section.s,
                key: section.key,
            };
            const countries = [];
            section.gi.forEach((country) => {
                const countryData = {
                    name: softvoyageData.g[country.g],
                    key: country.g,
                };

                const destinations = [];
                country.i.forEach((destination) => {
                    const destinationData = {
                        text: softvoyageData.i[destination],
                        key: destination,
                        checked: false,
                    };

                    destinations.push(destinationData);
                });
                countryData.destinations = destinations.sort(SoftvoyageData.modalSortDestinations);
                countries.push(countryData);
            });
            sectionData.countries = countries.sort(SoftvoyageData.modalSortCountries);
            modalData.push(sectionData);
        });

        modalData.forEach((section, sectionIndex) => {
            section.countries.forEach((country, countryIndex) => {
                country.destinations.forEach((destination, destinationIndex) => {
                    destination.value = `${sectionIndex}-${countryIndex}-${destinationIndex}`;
                });
            });
        });

        return modalData;
    }
}

const data = new SoftvoyageData();

export default data;
